import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import RankingSection from './components/RankingSection';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <MediaSection />
        <CarouselSection />
        <RankingSection />
        <IndexSection />
        <AppSection />
        <CardsSection />
        <FeaturesSection />
        <ContactSection />
        <TopicsSection />
        <UpdatesSection />
        <AboutSection />
        <CommentsSection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}